'use client';

import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { cn } from '@eliadmin/core/src/utils/style-utils';

interface MobileCarouselProps {
  className?: {
    main?: string;
    wrapper?: string;
    container?: string;
    slide?: string;
    mobileDotsConteiner?: string;
  };
  slides: React.ReactNode[];
}

export function MobileCarousel({ className, slides }: MobileCarouselProps) {
  return (
    <CarouselProvider>
      <Carousel
        mobileCarouselDots={true}
        slides={slides}
        className={{
          mobileDotsConteiner: cn(className?.mobileDotsConteiner),
          main: cn('h-full w-full', className?.main),
          wrapper: cn('h-full w-full', className?.wrapper),
          container: cn('h-full w-full gap-6', className?.container),
          slide: cn(className?.slide),
        }}
      />
    </CarouselProvider>
  );
}
